import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_bell_filled = _resolveComponent("bell-filled");

  var _component_checked = _resolveComponent("checked");

  var _component_user_filled = _resolveComponent("user-filled");

  var _component_avatar = _resolveComponent("avatar");

  var _component_WalletFilled = _resolveComponent("WalletFilled");

  var _component_GoodsFilled = _resolveComponent("GoodsFilled");

  var _component_Platform = _resolveComponent("Platform");

  var _component_StarFilled = _resolveComponent("StarFilled");

  var _component_Promotion = _resolveComponent("Promotion");

  var _component_ArrowRightBold = _resolveComponent("ArrowRightBold");

  var _component_list = _resolveComponent("list");

  var _component_HelpFilled = _resolveComponent("HelpFilled");

  var _component_Flag = _resolveComponent("Flag");

  var _component_UserFilled = _resolveComponent("UserFilled");

  var _component_TrendCharts = _resolveComponent("TrendCharts");

  var _component_Stamp = _resolveComponent("Stamp");

  var _component_Tools = _resolveComponent("Tools");

  var _component_CameraFilled = _resolveComponent("CameraFilled");

  var _component_el_image = _resolveComponent("el-image");

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createBlock(_component_el_icon, {
    size: 16
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_bell_filled, null, null, 512), [[_vShow, _ctx.iconFlag == 'daiban']]), _withDirectives(_createVNode(_component_checked, null, null, 512), [[_vShow, _ctx.iconFlag == 'gongzuo']]), _withDirectives(_createVNode(_component_user_filled, null, null, 512), [[_vShow, _ctx.iconFlag == 'thought']]), _withDirectives(_createVNode(_component_avatar, null, null, 512), [[_vShow, _ctx.iconFlag == 'avatar']]), _withDirectives(_createVNode(_component_WalletFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'meeting']]), _withDirectives(_createVNode(_component_GoodsFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'activity']]), _withDirectives(_createVNode(_component_Platform, null, null, 512), [[_vShow, _ctx.iconFlag == 'train']]), _withDirectives(_createVNode(_component_StarFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'learning']]), _withDirectives(_createVNode(_component_Promotion, null, null, 512), [[_vShow, _ctx.iconFlag == 'email']]), _withDirectives(_createVNode(_component_ArrowRightBold, null, null, 512), [[_vShow, _ctx.iconFlag == 'MultiColumn']]), _withDirectives(_createVNode(_component_list, null, null, 512), [[_vShow, _ctx.iconFlag == 'questionnaire']]), _withDirectives(_createVNode(_component_HelpFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'integral']]), _withDirectives(_createVNode(_component_Flag, null, null, 512), [[_vShow, _ctx.iconFlag == 'investigate']]), _withDirectives(_createVNode(_component_UserFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'person']]), _withDirectives(_createVNode(_component_TrendCharts, null, null, 512), [[_vShow, _ctx.iconFlag == 'gongzuos']]), _withDirectives(_createVNode(_component_Stamp, null, null, 512), [[_vShow, _ctx.iconFlag == 'democracy']]), _withDirectives(_createVNode(_component_Tools, null, null, 512), [[_vShow, _ctx.iconFlag == 'tools']]), _withDirectives(_createVNode(_component_CameraFilled, null, null, 512), [[_vShow, _ctx.iconFlag == 'wishCard']]), _withDirectives(_createVNode(_component_el_image, {
        class: "spot",
        src: require('@/assets/img/helpInPairs/helpInPairs_n.png')
      }, null, 8, ["src"]), [[_vShow, _ctx.iconFlag == 'helpInPairs' && _ctx.iconName != _ctx.getName]]), _withDirectives(_createVNode(_component_el_image, {
        class: "spot",
        src: require('@/assets/img/helpInPairs/helpInPairs_y.png')
      }, null, 8, ["src"]), [[_vShow, _ctx.iconFlag == 'helpInPairs' && _ctx.iconName == _ctx.getName]])];
    }),
    _: 1
  });
}